import Esittely from "../components/Esittely";


function EtusivuPage(){
    return <div>
        <Esittely/>
    </div>
}

export default EtusivuPage;